import { IModel } from "@/@types/models/model";
import { commonFields } from "./helpers/commonFields";

const Lokacije: IModel = {
    title: "Lokacije",
    source: "lokacije",
    apiPath: "operations/projekti/{projekt_id}/lokacije",
    forms : {
        "default": {
            fields: ["id", "kb", "kc"]
        },
        "insert": {
            fields: ["na_ime", "ul_ime", "kb", "zona", "ko_ime",  "kc", "lokacija_status_id", "komentar"],
        }
    },
    listViews: {
        "default": {
            fields: ["obj_id"],
            hidden: ["id"]
        },
        "radni_sastanci": {
            fields: [ "cut_id" , "na_ime", "ul_ime", "kb", "zona", "ko_ime",  "kc", "lokacija_status_id", "has_obveznik", "komentar"],
            hidden: ["id"]
        },
        "exportExcel": {
            fields: ["id" , "na_ime", "ul_ime", "kb", "zona", "ko_ime",  "kc", "lokacija_status_id", "komentar"]
        }
    },
    fields: [
        {
            title: "id",
            source: "id",
            ttoken: "common.id",
            tooltip: "lokacije.id",
            type: "numeric",
            idattr: true,
            readonly: true
        },
        {
            title: "cut_id",
            source: "cut_id",
            ttoken: "common.id",
            tooltip: "lokacije.id",
            type: "text",
            readonly: true
        },
        {
            title: "projekt id",
            source: "projekt_id",
            sort: false,
            ttoken: "lokacije.projekti_id",
            tooltip: "lokacije.projekti_id",
            type: "numeric"
        },
        {
            title: "kb",
            source: "kb",
            ttoken: "lokacije.kb",
            type: "text"
        },
        {
            title: "ul_ime",
            source: "ul_ime",
            ttoken: "lokacije.ul_ime",
            type: "text"
        },
        {
            title: "ul_jid",
            source: "ul_jid",
            ttoken: "lokacije.ul_jid",
            type: "numeric"
        },
        {
            title: "Naselje",
            source: "na_ime",
            ttoken: "lokacije.naselje",
            type: "text"
        },
        {
            title: "Naselje mb",
            source: "na_mb",
            ttoken: "lokacije.naselje_mb",
            type: "numeric"
        },
        {
            title: "Katastarska cestica",
            source: "kc",
            ttoken: "lokacije.kc",
            type: "text",
            sort: true
        },
        {
            title: "Katastarska opcina",
            source: "ko_ime",
            ttoken: "lokacije.ko",
            type: "text",
            sort: true
        },
        {
            title: "Status",
            source: "lokacija_status_id",
            ttoken: "lokacije.status",
            type: "numeric",
            sort: true
        },
        {
            title: "Zona",
            source: "zona",
            ttoken: "lokacije.zona",
            type: "text",
            sort: true
        },
        {
            title: "KN Koef",
            source: "kn_koef",
            ttoken: "lokacije.kn_koef",
            type: "numeric"
        },
        {
            title: "Komentar",
            source: "komentar",
            ttoken: "common.komentar",
            type: "text",
            sort: true
        },
        {
            title: "Has obveznik",
            source: "has_obveznik",
            ttoken: "lokacije.has_obveznik",
            type: "text",
            readonly: true,
            sort: true
        },
        {
            title: "fishnet",
            source: "fishnet",
            sort: true,
            ttoken: "objekti.fishnet",
            type: "numeric"
        },
        commonFields.wkt
    ]
}

export default Lokacije;
